import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectFieldOption } from '@sdbn/common';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject } from 'rxjs';
import { StructureSelection } from '../../../common/structure-selection/structure-selection.model';

@Component({
  selector: 'yard-station-type-condition-editor',
  standalone: false,
  templateUrl: './station-type-condition-editor.component.html',
  styleUrl: './station-type-condition-editor.component.scss',
})
export class StationTypeConditionEditorComponent implements OnInit, ConditionEditorContextConsumer {

  condition: ConditionEntry;

  currentSelection: any;

  options = new Array<SelectFieldOption>();

  formGroup = new FormGroup({
    type: new FormControl(null, [])
  });

  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        if (this.condition?.data) {
          this.formGroup.patchValue({ type: this.condition.data });
        }
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {

    this.options.push(new SelectFieldOption({
      labelDictionaryKey: 'tmc-yard.common.enum.station-type.WORKING_AREA',
      value: 'WORKING_AREA'
    }));

    this.options.push(new SelectFieldOption({
      labelDictionaryKey: 'tmc-yard.common.enum.station-type.WAITING_AREA',
      value: 'WAITING_AREA'
    }));

    this.formGroup.valueChanges.subscribe(value => {
      this.condition.data = value.type!;
    });

  }

  onSelectionChanged(selection: StructureSelection) {
    this.currentSelection = selection;
    this.condition.data = JSON.stringify(selection);
  }

}
